import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';



const DialogBLApp = ({ open, dialogTitle, app, setApp, blapp, setBLApp, version, setVersion, preApp, setPreApp, preVersion, setPreVersion, handleClose }) => {

  function handleApp(e) {
    setApp(e.target.value);
  }

  function handleBLApp(e) {
    setBLApp(e.target.value);
  }

  function handleVersion(e) {
    setVersion(e.target.value);
  }

  function handlePreApp(e) {
    setPreApp(e.target.value);
  }

  function handlePreVersion(e) {
    setPreVersion(e.target.value);
  }

  return (
  	<Dialog open={open} onClose={handleClose} maxWidth ='md' fullWidth>
        <DialogTitle sx={{ fontSize: '22px', color:"#406599", fontFamily: '"Roboto", "sans-serif"' }}>{dialogTitle}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="stable_app"
            label="Stable App"
            fullWidth
            variant="standard"
            value={app}
            onChange={handleApp}
          />
          <TextField
            margin="dense"
            id="stable_blapp"
            label="Stable BLApp"
            fullWidth
            variant="standard"
            value={blapp}
            onChange={handleBLApp}
          />
          <TextField
            margin="dense"
            id="stable_fw_version"
            label="Stable FW Version"
            fullWidth
            variant="standard"
            value={version}
            onChange={handleVersion}
          />
          <TextField
            margin="dense"
            id="pre_stable_app"
            label="Previous Stable App"
            fullWidth
            variant="standard"
            value={preApp}
            onChange={handlePreApp}
          />
          <TextField
            margin="dense"
            id="pre_fw_version"
            label="Previous FW Version"
            fullWidth
            variant="standard"
            value={preVersion}
            onChange={handlePreVersion}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Save</Button>
        </DialogActions>
     </Dialog>
  );
}

export default DialogBLApp;
